import { request, _urlPartner, _urlPartnerRequest } from "../api";
import {PARTNER_CONSTS} from "../constants";
import swal from "sweetalert";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetPartners = () => {
    const requestData = {
        url: _urlPartner,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNERS,
                    payload: data
                });
            })
    }
};
export const GetPartnerRequests = () => {
    const requestData = {
        url: _urlPartnerRequest,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PARTNER_CONSTS.GET_PARTNER_REQUESTS,
                    payload: data
                });
            })
    }
};

export const GetPartnerById = id => {
    const requestData = {
        url:  `${_urlPartner}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then((res) => {
                return res.data
            })
            .catch(() => {})
    }
};

export const DeletePartnerById = id => {
    const requestData = {
        url:  `${_urlPartner}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PARTNER_CONSTS.DELETE_PARTNER_BY_ID,
                    payload: id
                });
            })
            .catch(() => {})
    }
};


export const DeletePartnerRequestById = id => {
    const requestData = {
        url:  `${_urlPartnerRequest}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PARTNER_CONSTS.DELETE_PARTNER_REQUEST_BY_ID,
                    payload: id
                });
            })
            .catch(() => {})
    }
};

export const CreatePartner = data => {
    const requestData = {
        url: _urlPartner,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PARTNER_CONSTS.CREATE_PARTNER,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Գործընկերը հաջողությամբ ստեղծվեց!"
                })
                history.push('/partners')
            })
            .catch(() => {
            })
    }
};

export const UpdatePartnerById = (id, data) => {
    const requestData = {
        url: `${_urlPartner}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: PARTNER_CONSTS.UPDATE_PARTNER_BY_ID,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Գործընկերը հաջողությամբ փոփոխվեց!"
                })
                history.push('/partners')
            })
            .catch(() => {
            })
    }
};

export const UpdatePartnersPositions = items => {
    const requestData = {
        url: _urlPartner,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: PARTNER_CONSTS.UPDATE_PARTNERS_POSITIONS
                });
                notificationSuccess({
                    description: "Գործընկերը հաջողությամբ թարմացվեց!"
                })
            })
            .catch(() => {
            })
    }
};
